//libraries
import React, { Component } from "react";
import { Layout } from "antd";
//assets
import logo from "./logo.svg";
//components
import Redirect from "./components/Redirect";
import Instagram from "./components/Instagram";

const { Header, Content } = Layout;

export default class App extends Component {
  constructor(props) {
    super(props);
    this.qsParams = new URLSearchParams(window.location.search);
    this.state = {
      currentTab:
        this.qsParams.has("tab") && this.qsParams.get("tab").toLowerCase(),
    };
    this.tabs = {
      order: <Redirect qsParams={this.qsParams} />,
      amazon: <Redirect qsParams={this.qsParams} />,
      instagram: <Instagram qsParams={this.qsParams} />,
    };
  }

  render() {
    return (
      <Layout className="layout" style={{ backgroundColor: "white" }}>
        <Header style={styles.header}>
          <img style={styles.logo} src={logo} className="logo" alt="logo" />
        </Header>
        <Content style={styles.container}>
          {this.state.currentTab
            ? this.tabs[this.state.currentTab]
            : "Oops something went wrong. Please return to the email and click the button again."}
        </Content>
      </Layout>
    );
  }
}

const styles = {
  logo: { maxWidth: "40%", maxHeight: "50%", padding: 0, marginLeft: "4vw" },
  container: {
    padding: "8vh 10vw",
    display: "flex",
    justifyContent: "center",
  },
  header: {
    padding: 0,
    margin: 0,
    backgroundColor: "#fff",
    display: "flex",
    flexWrap: "no-wrap",
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: "0 1px 0 rgba(0,0,0,.1)",
    zIndex: 99,
    maxWidth: "100%",
  },
};
